/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Account } from '../models/Account';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AccountsService {
    /**
     * Get Accounts
     * @param limit
     * @param page
     * @returns any List of accounts
     * @throws ApiError
     */
    public static getAccounts(
        limit?: number,
        page?: number,
    ): CancelablePromise<{
        accounts?: Array<Account>;
        total?: number;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/account',
            query: {
                'limit': limit,
                'page': page,
            },
        });
    }
    /**
     * Get Account by name
     * @param address Account Name
     * @returns Account List of accounts
     * @throws ApiError
     */
    public static getAccountByName(
        address: any,
    ): CancelablePromise<Account> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/account/{address}',
            path: {
                'address': address,
            },
        });
    }
}
